/**
 * @param data
 * @param action
 *
 * if action != false do reload with action="open-account" in page url
 */
function show_change_regulation_popup( new_regulation_obj ){

    $("body").append('<div class="active-background-pop-regulation"></div>');
    //add active background
    $(".form-cover").addClass('active');

    create_regulation_popup(new_regulation_obj);

    insert_qr_pop_up_css( );
}

function create_regulation_popup(new_regulation_obj){
    var submitTxt  = (typeof submit_btn_text !== 'undefined') ? submit_btn_text : 'Submit' ;
    var change_regulation_popup = "<div class='popup_regulation'><div class='content'>" + new_regulation_obj.UserMessage + "</div>" +
        "<button class='btn btn-block btn-default btn-onboard ok_button_reload_page'>"
        + submitTxt +"</button></div>";

    $(change_regulation_popup).appendTo("body");

    $(document).on('click', '.ok_button_reload_page', function() {
        reload_page_with_url_param();
        return;
    });
}

function failur_popup_according_to_regulation( data  ){

    if( data[0]) {
        if(data[0].code != 'ValidationEx'){

            data[0].message = "<div class='popup_regulation'><div class='content'>"+data[0].message+"</div>" +
                "<button class='btn btn-block btn-default btn-onboard ok_button_reload_page'>"
                + 'Submit' +"</button></div>";

            //add active background
            $(".form-cover").addClass('active');

            $(document).on('click', '.ok_button_reload_page', function() {
                reload_page_with_url_param();
                return;
            });
            insert_qr_pop_up_css( );
        }
    }
}

function addParameterToURL(param){
    _hash = location.hash;
    _url = location.href.replace(location.hash, "");
    _url += (_url.split('?')[1] ? '&':'?') + param + _hash;
    return _url;
}

/**
 * Reload page after change regulation. Add url param open account to page url
 */
function reload_page_with_url_param(){

    if(/action=open-account/.test(window.location.href)){
        window.location.reload();
    } else {
        window.location.href = addParameterToURL('action=open-account');
    }

}

function insert_qr_pop_up_css( ){
    var url = window.location.host.match(/local|qa|qa2|qa4|sandbox|con|int/);
    envprefix = '';
    if(url){
        envprefix = url[0];
    }
    var head  = document.getElementsByTagName('head')[0];
    var link  = document.createElement('link');
    link.rel  = 'stylesheet';
    link.type = 'text/css';
    link.href = '//'+ envprefix+'www.' + window.location.host.split('.')[1] + '.com/shared/lib/popup_css/style.css';
    link.media = 'all';
    head.appendChild(link);
}

